import BottomTabs from './BottomTabs';

export default BottomTabs;
